import React, { useEffect, useState } from "react";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import Grid from "@origyn-sa/common-ui/src/components/atoms/Grid";
import SearchInput from "@origyn-sa/common-ui/src/components/molecules/SearchInput";
import Select from "@origyn-sa/common-ui/src/components/molecules/Select";
import StyledItemGrid from "@origyn-sa/common-ui/src/components/atoms/ItemGrid";
import ProductCard from "@origyn-sa/common-ui/src/components/molecules/ProductCard";
import ExploreStyled from "./Explore.styled";
import Text from "@origyn-sa/common-ui/src/components/atoms/Text";
import { fetchExploreItems } from "../../utils";
import { LinearProgress } from "@material-ui/core";

const MarketplaceExplore = () => {
  const [loader, setLoader] = useState<boolean>(true);
  const [itemsList, setItemsList] = useState<any[]>([]);
  const refreshExploreItems = () => {
    setLoader(true);
    fetchExploreItems()
      .then((data: any) => {
        setItemsList(data);
      })
      .finally(() => setLoader(false));
  };

  useEffect(() => {
    refreshExploreItems();
    const interval = setInterval(() => refreshExploreItems(), 10000);
    return () => clearInterval(interval);
  }, []);

  console.log(itemsList);

  return (
    <>
      {loader && (
        <LinearProgress
          style={{ position: "fixed", top: 0, left: 0, width: "100%" }}
        />
      )}
      <ExploreStyled>
        <Grid columns={5}>
          <Grid className='topGrid' columns={4}>
            <Grid
              columns={4}
              style={{
                gridColumnStart: 1,
                gridColumnEnd: 5,
              }}
            >
              <SearchInput
                disabled
                className='gridSearchInput'
                placeholder='Search items, collections and accounts'
              />
              <Select small placeholder='Sort by' />
              <Button small textBtn className='displayButtonFilter'>
                FILTER
              </Button>
            </Grid>
            <StyledItemGrid
              style={{ gridColumnStart: 1, gridColumnEnd: 5 }}
              maxColumns={4}
            >
              {itemsList.length ? (
                itemsList.map((item: any) => (
                  <ProductCard
                    key={item.id}
                    productUrl={`/market/${item.canisterId}/${item.id}`}
                    productImage={item.image || ""}
                    productName={item.name || ""}
                    productCase={`ID: ${item.id}` || ""}
                    owner={item.owner}
                  />
                ))
              ) : (
                <Text>No items</Text>
              )}
            </StyledItemGrid>
          </Grid>
        </Grid>
      </ExploreStyled>
    </>
  );
};

export default MarketplaceExplore;
